export const selfAssessmentQuestions = {
  Reading: {
    k1: [
      'Kann das Kind ähnlich klingende Wörter unterscheiden?',
      'Kann das Kind ein vorgesprochenes Wort mündlich in Silben gliedern?',
      'Kann das Kind heraushören, ob ein bestimmter Laut in einem Wort vorkommt?',
      'Kann das Kind Einzellaute zu einem Wort zusammenbinden?',
      'Kann das Kind einem Laut den zugehörigen Buchstaben bzw. die zugehörige Buchstabengruppe zuordnen?'
    ],
    k2: [
      'Kann das Kind Wörter mit einfacher Silbenstruktur und häufig vorkommenden Buchstabenkombinationen lesen?',
      'Kann das Kind einfache Wörter mit häufig vorkommenden Konsonantenfolgen am Silbenanfang lesen?',
      'Kann das Kind Silbenbögen unter ein Wort malen?',
      'Kann das Kind neue einfache Wörter erlesen?',
      'Kann das Kind einfache Wörter flüssig lesen und verstehen?'
    ],
    k3: [
      'Kann das Kind Pseudowörter lesen?',
      'Kann das Kind zunehmend schwierige oder unbekannte Wörter lesen?',
      'Kann das Kind bekannte Wörter im Ganzen lesen, ohne zu lautieren?',
      'Beherrscht das Kind das automatisierte, schnelle Erkennen von häufigen und bekannten Wörtern, das sogenannte Blitzlesen?'
    ],
    k4: [
      'Kann das Kind einen Satz lesen und dabei den Inhalt verstehen?',
      'Kann das Kind mehrere inhaltlich zusammenhängende Sätze hintereinander lesen und verstehen?',
      'Kann das Kind in einem Text die wichtigsten Stellen identifizieren, die den Textinhalt repräsentieren?',
      'Kann das Kind unverstandene Wörter und Textstellen kennzeichnen?',
      'Kann das Kind das Gelesene in eigenen Worten zusammenfassen?'
    ]
  },
  Writing: {
    k1: [
      'Kann das Kind ähnlich klingende Wörter unterscheiden?',
      'Kann das Kind ein vorgesprochenes Wort mündlich in Silben gliedern?',
      'Kann das Kind heraushören, ob ein bestimmter Laut in einem Wort vorkommt?',
      'Kann das Kind Einzellaute zu einem Wort zusammenbinden?',
      'Kann das Kind einem Laut den zugehörigen Buchstaben bzw. die zugehörige Buchstabengruppe zuordnen?'
    ],
    k2: [
      'Kann das Kind Wörter mit einfacher Silbenstruktur und häufig vorkommenden Buchstabenkombinationen schreiben?',
      'Kann das Kind einfache Wörter mit häufig vorkommenden Konsonantenfolgen am Silbenanfang schreiben?',
      'Kann das Kind Silbenbögen unter ein Wort malen?',
      'Kann das Kind bereits geübte einfache Wörter, die regelmäßig und lautgetreu sind, schreiben?',
      'Kann das Kind neue oder nicht geübte einfache Wörter, die regelmäßig und lautgetreu sind, schreiben?'
    ],
    k3: [
      'Beherrscht das Kind die Rechtschreibregeln?',
      'Kann das Kind richtig mit Lupenstellen umgehen (Stellen in einem Wort, die häufig zu Rechtschreibfehlern führen)?',
      'Kann das Kind Wörter schreiben, die nicht lautgetreu sind, bei denen sich die Schreibweise aber durch Strategien ableiten lässt?',
      'Kann das Kind Zeitformen beim Schreiben richtig anwenden?',
      'Kann das Kind die verschiedenen Wortarten richtig nutzen?'
    ],
    k4: [
      'Kann das Kind diktierte Sätze richtig schreiben?',
      'Kann das Kind Wörter in Schreibschrift richtig abschreiben?',
      'Kann das Kind diktierte Sätze in Schreibschrift schreiben?',
      'Kann das Kind in Schreibschrift schreiben, sodass das Schriftbild leserlich ist?',
      'Kann das Kind in Schreibschrift in einem angemessenen Tempo schreiben?'
    ]
  },
  Counting: {
    k1: [
      'Kann das Kind fehlerfrei im behandelten Zahlenraum zählen?',
      'Weiß das Kind, welche von zwei Zahlen größer ist?',
      'Kann das Kind einer Menge von Objekten die entsprechende Zahl zuordnen?',
      'Kann das Kind einer Zahl die entsprechende Menge an Objekten zuordnen?',
      'Kann das Kind Zahlen in die richtige Reihenfolge bringen und weiß, welche Zahl vor und nach einer bestimmten Zahl kommt?'
    ],
    k2: [
      'Kann das Kind Mengen in Teilmengen zerlegen?',
      'Kann das Kind mit Zuhilfenahme von konkreten Objekten Mengen addieren?',
      'Kann das Kind mit Zuhilfenahme von konkreten Objekten subtrahieren?',
      'Kann das Kind mit Zuhilfenahme von konkreten Objekten dividieren?',
      'Kann das Kind mit Zuhilfenahme von konkreten Objekten multiplizieren?'
    ],
    k3: [
      'Kann das Kind Additionsaufgaben ohne Objekte und nur mit Ziffern im behandelten Zahlenraum lösen?',
      'Kann das Kind Subtraktionsaufgaben ohne Objekte und nur mit Ziffern im behandelten Zahlenraum lösen?',
      'Kann das Kind Divisionsaufgaben ohne Objekte und nur mit Ziffern im behandelten Zahlenraum lösen?',
      'Kann das Kind Multiplikationsaufgaben ohne Objekte und nur mit Ziffern im behandelten Zahlenraum lösen?',
      'Ist das Kind in der Lage Rechenergebnisse von einfachen Aufgaben direkt aus dem Gedächtnis abzurufen, ohne zu rechnen?'
    ],
    k4: [
      'Kann das Kind im behandelten Zahlenraum schriftlich addieren, subtrahieren, multiplizieren und dividieren, indem die einzelnen Zahlen untereinandergeschrieben werden?',
      'Kann das Kind aus Textaufgaben die relevanten Informationen entnehmen und rechnerisch umsetzen?',
      'Kann das Kind komplexe Zahlenreihen im behandelten Zahlenraum vervollständigen?',
      'Kann das Kind mit den behandelten Maßeinheiten umgehen?',
      'Kann das Kind nach Vorgaben geometrische Formen zeichnen?'
    ]
  }
};
